import { useCallback } from 'react';

import {
  useWorkspaceActions,
  useCustomerActions,
  useCustomerCanCreateFeatureItem,
} from 'src/store';
import { FEATURE_LIMITS } from 'src/data/featureLimits';
import {
  useCreateOrUpdateWorkspace,
  useDeleteWorkspace,
  useUpgradePopup,
} from 'src/services/popup';

export const useHandlers = ({ closeMenu }) => {
  const customerActions = useCustomerActions();
  const createWorkspace = useCreateOrUpdateWorkspace();
  const deleteWorkspace = useDeleteWorkspace();
  const workspaceStoreActions = useWorkspaceActions();
  const openUpgradePopup = useUpgradePopup();

  const customerCanCreateWorkspaces = useCustomerCanCreateFeatureItem(
    FEATURE_LIMITS.workspacesPerCustomer
  );

  const handleMenuClose = useCallback(() => {
    closeMenu();
  }, [closeMenu]);

  const handleDeleteWorkspace = useCallback(
    (workspace) => {
      handleMenuClose();
      deleteWorkspace(workspace);
    },
    [handleMenuClose, deleteWorkspace]
  );

  const handleWorkspaceClick = useCallback(
    (workspace) => {
      handleMenuClose();

      workspaceStoreActions.selectCurrentWorkspace(workspace.id);
      customerActions.refreshCurrentCustomerFeatureLimit();
    },
    [handleMenuClose, workspaceStoreActions, customerActions]
  );

  const handleAddWorkspace = useCallback(
    (workspace) => {
      if (!customerCanCreateWorkspaces && !workspace) {
        openUpgradePopup(FEATURE_LIMITS.workspacesPerCustomer);
        return;
      }
      handleMenuClose();
      createWorkspace(workspace);
    },
    [customerCanCreateWorkspaces, openUpgradePopup, handleMenuClose, createWorkspace]
  );

  return {
    handleMenuClose,
    handleWorkspaceClick,
    handleAddWorkspace,
    handleDeleteWorkspace,
  };
};
